export default {
  'Trulimero Trulicina': {
    health: 125,
    rarity: 'Rare',
  },
  'La Vacca Saturno Saturnita': {
    health: 55000,
    rarity: 'Secret',
  },
  //   'Cocotanko Giraffanto': {
  //     health: 250000,
  //     DontSpawn: true,
  //     rarity: 'Godly',
  //   },
  'Pipi Kiwi': {
    health: 150,
    rarity: 'Rare',
  },
  //   67: {
  //     health: 676767,
  //     DontSpawn: true,
  //     rarity: 'Limited',
  //   },
  'Tralalero Tralala': {
    health: 23500,
    rarity: 'Godly',
  },
  //   'Frigo Camelo': {
  //     health: 5000,
  //     rarity: 'Mythic',
  //   },
  'Tim Cheese': {
    health: 225,
    rarity: 'Rare',
  },
  'Bombardiro Crocodilo': {
    health: 7250,
    rarity: 'Mythic',
  },
  //   'Svinino Pumpkinino': {
  //     health: 15000,
  //     DontSpawn: true,
  //     rarity: 'Epic',
  //   },
  //   'Svinino Bombondino': {
  //     health: 500,
  //     rarity: 'Epic',
  //   },
  //   'Dragonfrutina Dolphinita': {
  //     health: 25000,
  //     DontSpawn: true,
  //     rarity: 'Legendary',
  //   },
  'Cappuccino Assassino': {
    health: 500,
    rarity: 'Epic',
  },
  //   'Bandito Bobrito': {
  //     health: 5000,
  //     rarity: 'Epic',
  //   },
  //   'Squalo Cavallo': {
  //     health: 100000,
  //     DontSpawn: true,
  //     rarity: 'Limited',
  //   },
  //   'Secret Lucky Egg': {
  //     Egg: true,
  //     health: 50000,
  //     rarity: 'Secret',
  //   },
  'Pot Hotspot': {
    rarity: 'Secret',
    health: 185000,
    Event: 'RainbowEvent',
    EventMutation: 'Rainbow',
  },
  'Glorbo Fruttodrillo': {
    health: 100000,
    DontSpawn: true,
    rarity: 'Mythic',
  },
  'Trippi Troppi': {
    health: 550,
    rarity: 'Epic',
  },
  'Orcalero Orcala': {
    health: 2500,
    rarity: 'Epic',
  },
  //   'Orangutini Strawberrini': {
  //     health: 2500,
  //     DontSpawn: true,
  //     rarity: 'Rare',
  //   },
  'Gangster Footera': {
    health: 1400,
    rarity: 'Legendary',
  },
  'Bambini Crostini': {
    health: 650,
    rarity: 'Epic',
  },
  //   'Godly Lucky Egg': {
  //     Egg: true,
  //     health: 25000,
  //     rarity: 'Godly',
  //   },
  'Brr Brr Patapim': {
    health: 500,
    rarity: 'Epic',
  },
  Matteo: {
    health: 25000,
    rarity: 'Godly',
  },
  'Ballerina Cappuccina': {
    health: 1000,
    rarity: 'Legendary',
  },
  //   'Blueberrinni Octopussini': {
  //     rarity: 'Secret',
  //     health: 100000,
  //     Event: 'GalacticEvent',
  //     EventMutation: 'Galactic',
  //   },
  Alessio: {
    health: 1000,
    rarity: 'Epic',
  },
  //   'Chef Crabacadabra': {
  //     health: 48600,
  //     DontSpawn: true,
  //     rarity: 'Limited',
  //   },
  //   Madung: {
  //     health: 1800,
  //     rarity: 'Legendary',
  //   },
  'Noobini Pizzanini': {
    health: 100,
    rarity: 'Rare',
  },
  //   'Meme Lucky Egg': {
  //     Egg: true,
  //     health: 150000,
  //     rarity: 'Limited',
  //   },
  //   'Bredda Ratto': {
  //     health: 300000,
  //     DontSpawn: true,
  //     rarity: 'Limited',
  //   },
  'Odin Din Din Dun': {
    health: 15000,
    rarity: 'Godly',
  },
  //   'Noobini Cactusini': {
  //     health: 1000,
  //     DontSpawn: true,
  //     rarity: 'Rare',
  //   },
  //   'Esok Sekolah': {
  //     health: 32400,
  //     DontSpawn: true,
  //     rarity: 'Limited',
  //   },
  'Los Tralaleritos': {
    health: 50000,
    rarity: 'Secret',
  },
  //   'Los Mr Carrotitos': {
  //     health: 1250000,
  //     DontSpawn: true,
  //     rarity: 'Secret',
  //   },
  //   'Burbaloni Lulliloli': {
  //     health: 1500,
  //     rarity: 'Legendary',
  //   },
  //   'Carnivourita Tralalerita': {
  //     health: 750000,
  //     DontSpawn: true,
  //     rarity: 'Godly',
  //   },
  'Las Tralaleritas': {
    health: 1650,
    rarity: 'Legendary',
  },
  'Girafa Celestre': {
    health: 17500,
    rarity: 'Godly',
  },
  Fluriflura: {
    health: 250,
    rarity: 'Rare',
  },
  'Brri Brri Bicus Dicus Bombicus': {
    rarity: 'Secret',
    health: 125000,
    Event: 'GoldenEvent',
    EventMutation: 'Gold',
  },
  'Orangutini Ananassini': {
    health: 150,
    rarity: 'Rare',
  },
  'Bananita Dolphinita': {
    health: 1250,
    rarity: 'Legendary',
  },
  'Gattatino Neonino': {
    health: 1000000,
    DontSpawn: true,
    rarity: 'Limited',
  },
  'Boneca Ambalabu': {
    health: 200,
    rarity: 'Rare',
  },
  'Espresso-Signora': {
    health: 1250,
    rarity: 'Rare',
  },
  //   'Brr Brr Sunflowerim': {
  //     health: 10000,
  //     DontSpawn: true,
  //     rarity: 'Epic',
  //   },
  'Rhino Toasterino': {
    health: 21600,
    DontSpawn: true,
    rarity: 'Limited',
  },
  //   'Dragon Cannelloni': {
  //     health: 145800,
  //     DontSpawn: true,
  //     rarity: 'Limited',
  //   },
  'Bombombini Gusini': {
    health: 6500,
    rarity: 'Mythic',
  },
  'Cocofanto Elefanto': {
    health: 1550,
    rarity: 'Legendary',
  },
  //   'Arminini Bodybuilderini': {
  //     health: 50000,
  //     DontSpawn: true,
  //     rarity: 'Limited',
  //   },
  //   'Agarrini La Palini': {
  //     health: 250,
  //     rarity: 'Rare',
  //   },
  //   'Eggplantini Burbalonini': {
  //     health: 25000,
  //     DontSpawn: true,
  //     rarity: 'Legendary',
  //   },
  //   'Hotspotini Burrito': {
  //     health: 15000,
  //     DontSpawn: true,
  //     rarity: 'Limited',
  //   },
  //   'Crazylone Pizaione': {
  //     health: 75000,
  //     rarity: 'Secret',
  //   },
  'Lirili Larila': {
    health: 180,
    rarity: 'Rare',
  },
  //   Garamararam: {
  //     health: 76500,
  //     rarity: 'Secret',
  //   },
}
